const initialState = {
  searchResults: {},
  tableLoading: false,
};

const HistoryReducer = (state = initialState, action) => {
  const { type, payload, data } = action;

  switch (type) {
    case "SET_BILLING_RESULTS":
      return {
        ...state,
        searchResults: data.content,
        totalItems: data.totalItems,
        totalPages: data.totalPages,
        currentPage: data.page,
      };

    case "SET_TABLE_LOADING":
      return {
        ...state,
        tableLoading: payload, // true or false
      };

    default:
      return state;
  }
};

export default HistoryReducer;
